import React from 'react';
import { Modal, Spinner } from "react-bootstrap";

interface LoadingOverlayProps {
  show: boolean;
  text?: string; // Optional text to display in the loader
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ show, text }) => {
  return (
    <Modal show={show} centered backdrop="static" keyboard={false}>
      <Modal.Body className="text-center">
        <Spinner animation="border" variant="primary" />
        <div>{text || 'Loading.....'}</div> {/* Display custom text or default text */}
      </Modal.Body>
    </Modal>
  );
};
  
  export default LoadingOverlay;


